export const PATH_PAYMENT = "/user-payment-history";

export function getUserPaymentHistoryPreUsed() {
  return this.http.get(`${PATH_PAYMENT}/pre-used`);
}

export function getUserPaymentHistoryPaid() {
  return this.http.get(`${PATH_PAYMENT}/paid`);
}
